import React from 'react';

import { ChildrenPropType } from '../../../../prop-types/children';

import style from './configure-shipment-form.module.less';

const ConfigureShipmentForm = ({ children }) => <div className={style['configure-shipment-form']}>{children}</div>;

export default ConfigureShipmentForm;

ConfigureShipmentForm.propTypes = {
  children: ChildrenPropType.isRequired,
};
